var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualTestingWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 113,
    viewBox: "0 0 143 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1349 53.6394C20.4398 76.6987 40.1913 94.8097 63.2154 93.9294C86.2395 93.0491 103.728 73.6243 102.423 50.565C101.118 27.5057 81.3666 9.39461 58.3425 10.2749C35.3183 11.1553 17.7964 30.433 19.1349 53.6394Z",
    fill: "url(#paint0_linear_10935_81842)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7406 27.571C92.0567 29.2499 95.5828 37.8003 101.383 51.7886C101.933 50.1966 105.38 37.5511 93.7406 27.571Z",
    fill: "url(#paint1_linear_10935_81842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.01 24.493C99.7868 21.1439 98.1831 29.0825 93.5889 26.7853C98.3369 33.0672 100.63 37.6666 102.021 48.2066C105.242 46.0848 107.719 43.5785 107.895 41.756C108.07 39.9335 105.778 39.2556 104.311 37.4985C102.845 35.7414 103.472 26.6947 102.01 24.493Z",
    fill: "url(#paint2_linear_10935_81842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.053 85.9683C51.4344 90.4085 31.918 78.1371 27.4617 58.5593C23.0054 38.9816 35.2969 19.5112 54.9155 15.071C74.534 10.6308 94.0505 22.9022 98.5068 42.4799C102.963 62.0576 90.6716 81.5281 71.053 85.9683Z",
    fill: "url(#paint3_linear_10935_81842)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3093 83.5095C52.0747 87.6365 33.9348 76.2307 29.7929 58.034C25.651 39.8372 37.0754 21.7402 55.3101 17.6132C73.5448 13.4862 91.6846 24.892 95.8265 43.0887C99.9684 61.2855 88.544 79.3825 70.3093 83.5095Z",
    fill: "url(#paint4_linear_10935_81842)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10935_81842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.9805,
    height: 4.97947,
    transform: "matrix(-0.00202619 -0.999713 1.00028 -0.000882756 38.4872 55.0469)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9805,
    height: 4.97947,
    transform: "matrix(-0.00202619 -0.999713 1.00028 -0.000882756 42.1757 50.3477)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9805,
    height: 4.97948,
    transform: "matrix(-0.00202622 -0.999713 1.00028 -0.000882756 46.5461 50.3398)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9805,
    height: 4.97948,
    transform: "matrix(-0.00202622 -0.999713 1.00028 -0.000882756 50.2432 55.0312)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10935_81842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.26646,
    height: 4.26559,
    transform: "matrix(-0.00202612 -0.999714 1.00028 -0.000882856 79.114 47.6406)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.26646,
    height: 4.26559,
    transform: "matrix(-0.00202612 -0.999714 1.00028 -0.000882856 82.2734 43.6172)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.26646,
    height: 4.26558,
    transform: "matrix(-0.00202609 -0.999714 1.00028 -0.000882856 86.0178 43.6094)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.26646,
    height: 4.26559,
    transform: "matrix(-0.00202609 -0.999714 1.00028 -0.000882856 89.1843 47.6289)",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.9001 40.66C23.6639 42.0188 24.5232 54.092 25.8949 73.8566C24.4164 72.1227 13.6867 57.9553 20.9001 40.66Z",
    fill: "url(#paint5_linear_10935_81842)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48972 46.5142C8.57126 42.3495 15.5047 48.3238 19.986 45.2718C23.0197 55.6122 23.6024 62.1778 24.6548 71.6533C18.804 71.5646 13.3372 68.5202 11.9694 67.0172C10.6016 65.5141 13.0413 63.3124 14.0321 60.9623C15.0228 58.6122 6.77872 49.2521 7.48972 46.5142Z",
    fill: "url(#paint6_linear_10935_81842)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7129 48.1137L69.3193 46.6565",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9027 53.167C59.9025 62.057 52.0059 68.4289 43.3079 67.4534C34.61 66.4778 28.326 58.5152 29.3262 49.6252C30.3264 40.7352 38.2231 34.3632 46.921 35.3388C55.619 36.3144 61.9029 44.2769 60.9027 53.167Z",
    stroke: "white",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9714 45.2392C99.0125 53.7628 91.314 59.8999 82.7723 58.9419C74.2306 57.9838 68.0877 50.2941 69.0466 41.7706C70.0056 33.247 77.7041 27.1098 86.2458 28.0679C94.7875 29.026 100.93 36.7157 99.9714 45.2392Z",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8955 89.4766L85.278 103.978",
    stroke: "#9BCA3B",
    strokeWidth: 3.55324,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2895 95.9839L93.291 91.1695C93.0335 90.9215 92.6277 90.9155 92.363 91.1559L83.1982 99.477C80.8281 101.629 80.9903 105.403 83.5362 107.344C85.744 109.026 88.8904 108.644 90.6315 106.482L98.3474 96.8993C98.5681 96.6252 98.543 96.228 98.2895 95.9839Z",
    fill: "#6BB545"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7507,
    ry: 21.7703,
    transform: "matrix(-0.450162 0.892947 -0.893491 -0.449081 113.599 72.7003)",
    fill: "#6BB545"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.954 81.6908L106.431 60.1418C106.507 59.7744 106.867 59.5383 107.235 59.6144L126.134 63.5291C126.67 63.6401 126.861 64.3067 126.466 64.6851L117.786 72.9885C117.587 73.1784 117.522 73.4692 117.622 73.7253L122.195 85.506C122.39 86.008 121.95 86.5265 121.423 86.4173L102.481 82.4939C102.114 82.4177 101.878 82.0582 101.954 81.6908Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10935_81842",
    x: 34.4771,
    y: 45.3564,
    width: 24.7471,
    height: 17.6905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10935_81842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10935_81842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10935_81842",
    x: 75.1055,
    y: 39.3403,
    width: 22.3457,
    height: 16.3003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10935_81842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10935_81842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10935_81842",
    x1: 85.6804,
    y1: -4.00936,
    x2: 31.4885,
    y2: 97.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.5e-7,
    stopColor: "#E6FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7158,
    stopColor: "#D2DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10935_81842",
    x1: 84.4223,
    y1: 31.7088,
    x2: 118.216,
    y2: 60.3146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10935_81842",
    x1: 109.02,
    y1: 24.9279,
    x2: 88.4159,
    y2: 50.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10935_81842",
    x1: 48.2529,
    y1: 102.099,
    x2: 75.9917,
    y2: 4.67911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10935_81842",
    x1: 70.9209,
    y1: 22.1001,
    x2: 53.8868,
    y2: 81.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10935_81842",
    x1: 33.3554,
    y1: 41.8085,
    x2: 5.99875,
    y2: 87.8779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10935_81842",
    x1: 0.0424837,
    y1: 52.8641,
    x2: 34.5807,
    y2: 77.6252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0037BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#0036C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualTestingWelcome);
export default __webpack_public_path__ + "static/media/visual-testing-welcome.f8aabe3bb36bd91f882f5b75d122ecd5.svg";
export { ForwardRef as ReactComponent };